import React from "react";
import "./CollegeGrievanceCommittee.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const committeeMembers = [
  { srNo: "1", name: "Dr. Vinita Gaikwad", designation: "Director" },
  { srNo: "2", name: "Ms. Sonu Gupta", designation: "Member Secretary" },
  { srNo: "3", name: "Ms. Aprajita Singh", designation: "Member" },
  { srNo: "4", name: "Ms. Rashmi Vipat", designation: "Member" },
  { srNo: "5", name: "Ms. Rupali Jadhav", designation: "Member" },
  { srNo: "6", name: "Ms. Mira Gohil", designation: "Member" },
  { srNo: "7", name: "Ms. Pritam Rane", designation: "Member" },
  { srNo: "8", name: "Ms. Snehali Vaidya", designation: "NGO Member, Swadhar Kendra" },
];

const WomensGrievanceCommittee = () => {
  return (
    <>
      <Navbar />
      <PageHeader 
        title="Women's Grievance Redressal Committee" 
        crumbs={[{ label: 'Home', href: '/' }, { label: "Women's Grievance Redressal Committee" }]} 
      />
      <div className="cgc-page">
        <div className="cgc-container">
          <header className="cgc-header">
            <p className="cgc-overline">Subject: Women’s “Grievance Redressal Committee”</p>
            <p className="cgc-subtitle">
              Women’s Grievances Redressal Committee for the academic year 2020-21 
              has been constituted with following members in the team:
            </p>
          </header>

          <section className="cgc-table-section" aria-label="Women's grievance committee members">
            <div className="cgc-table-wrap">
              <table className="cgc-table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Name of the Faculty</th>
                    <th>Designation</th>
                  </tr>
                </thead>
                <tbody>
                  {committeeMembers.map((member) => (
                    <tr key={member.srNo}>
                      <td data-label="Sr. No.">{member.srNo}</td>
                      <td data-label="Name of the Faculty">{member.name}</td>
                      <td data-label="Designation">{member.designation}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section className="cgc-note-section" aria-label="Committee note">
            <p className="cgc-note-text">
              All are requested to take a note of the same &amp; carry out the duties
              as per the Institute guidelines in order to ensure natural justice to
              the stakeholders.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WomensGrievanceCommittee;